
import '@/styles/global.scss';
import '../faust.config';
import { useRouter } from 'next/compat/router';
import { FaustProvider } from '@faustwp/core';
import '@faustwp/core/dist/css/toolbar.css';
import { WordPressBlocksProvider } from '@faustwp/blocks';
import blocks from '../wp-blocks';
import { GoogleTagManagerScript } from '@/components';
import NetspendProvider from 'library/contexts/NetspendContext';
import { useEffect } from 'react';

export default function MyApp({ Component, pageProps }) {
	const router = useRouter();

  useEffect(() => {
    // Braze Session
		import('@/helpers/brazeExports').then(({ initialize, openSession }) => {
			initialize(process.env.BRAZE_PROD_API_KEY || process.env.BRAZE_DEV_API_KEY, {
				baseUrl: 'sdk.iad-06.braze.com',
				enableLogging: process.env.BRAZE_PROD_API_KEY ? false : true,
			});
			openSession();
		});
	}, []);

	return (
		<NetspendProvider>
			<FaustProvider pageProps={pageProps}>
				<WordPressBlocksProvider
					config={{
						blocks,
						theme: null,
					}}>
					<GoogleTagManagerScript gtmId="GTM-MKKNC9CM" />
					<Component {...pageProps} key={router.asPath} />
				</WordPressBlocksProvider>
			</FaustProvider>
		</NetspendProvider>
	);
}
